module finadai.models {
	export interface User extends GeneralProperties {
		id: number;
		email: string;
		privilege: string;
		rfc: string;
		name: string;
		last_name: string;
		phone: string
        pdf: string;
        pdf_paid: string;
        customer_number: string;
		operations: Array<string>;
		states: Array<string>;
        due_negotiation: number;
	}

	export interface Agent extends GeneralProperties {
		id: number;
		name: string;

		user: User;
	}

	export interface Customer extends GeneralProperties {
		id: number;
		name: string;
		last_name: string;
		customer_number: string;
		birth_date: Timestamp;

		user: User;
		locations: Array<Location>;
		phones: Array<Phone>;
		emails: Array<Email>;
		negotiations: Array<Negotiation>;
		logs: Array<Log>;
		all_logs: Array<Log>;
	}

	export interface Location extends GeneralProperties {
		id: number;
		name: string;
		address1: string;
		address2: string;
		city: string;
		state: string;
		country: string;
		zip: string;
		primary: number;
		logs: Array<Log>;
	}

	export interface Phone extends GeneralProperties {
		id: number;
		type: string;
		type_icon: string;
		num: string;
		primary: number;
		logs: Array<Log>;
	}

	export interface Email extends GeneralProperties {
		id: number;
		email: string;
		primary: number;
		logs: Array<Log>;
	}

	export interface ActivityType extends GeneralProperties {
		id: number;
		name: string;
	}

	export interface Cause extends GeneralProperties {
		id: number;
		name: string;
	}

	export interface File extends GeneralProperties {
		id: number;
		file_name: string;
		name: string;
		url: string;
	}

	export interface Activity extends GeneralProperties {
		id: number;
		comments: string;
		customer_number: string;

		agent?: Agent;
		type?: ActivityType;
	}

	export interface PaymentType extends GeneralProperties {
		id: number;
		name: string;
		minimum: number;
	}

	export interface Payment extends GeneralProperties {
		amount: number;
	}

	export interface Credit extends GeneralProperties {
		id: number;
		amount: number;
		loan_id: number;
		grant_date: Timestamp;
		last_payment: Timestamp;
		monthly_payment: number;
		pending_amount: number;
		amount_payable: number;
		rate: number;
		term: number;
		customer_number: string;
		loan_type_id: number;

		loan_type: LoanType;
		granter: Granter;
		negotiation?: Negotiation;
		customer?: Customer;
		co_accredit_data?: http.responses.CoAccredits;
	}

	export interface LoanType extends GeneralProperties {
		id: number;
		name: string;
	}

	export interface Granter extends GeneralProperties {
		id: number;
		name: string;
		deposit_data: string;
	}

	export interface Negotiation extends GeneralProperties {
		id: number;
		payment_amount: number;
		customer_number: string;
		state: string;

		agent?: Agent;
		credits?: Credit[];
		customer?: Customer;
		payment_type?: PaymentType;
		payments?: Payment[];
	}

	export interface GeneralProperties {
		created_at: Timestamp;
		updated_at: Timestamp;
		deleted_at: Timestamp;
	}

	export interface Timestamp {
		date: string;
		_date: Date;
		timezone: string;
		timezone_type: number;
	}

	export interface Log extends GeneralProperties {
		ip?: string;
		new_value: any;
		old_value: any;
		user?: User;
		owner_type: string;
	}
}
module finadai.models.misc {
	export interface Paginator {
		count: number;
		current_page: number;
		has_more: boolean;
		next_page_url: string;
		previous_page_url: string;
		per_page: number;
	}
}
module finadai.models.http.responses {
	export interface Login {
		error?: string;
		token: string;
	}

	export interface CoAccredits {
		customers: Customer[];
		total_amount: number;
		total_pending: number;
	}

	export interface AuthMe {
		user: User;
	}

	export interface Error {
		error: string;
		errors: any;
		message: string;
	}

	export interface Message {
		message: string;
	}

	export interface Records<T> {
		data: Array<T>;
		paginator?: misc.Paginator;
	}

	export interface Record<T> {
		data: T;
	}

	export interface ProxyRecord<T> {
		Data: T;
	}
}
module finadai.models.proxy {
	export interface Find{
        Saldo: Saldo | Array<Saldo>;
		Customer: Customer;
	}
	export interface Credito {
		Saldo: Saldo | Array<Saldo>;
	}
	export interface Saldo {
		CreditoId: string;
		TipoProducto: string;
		FechaApertura: Date;
		Plazo: number;
		Tasa: string;
		MontoSolicitado: string;
		FechaUltimoPago: Date;
		Capital: string;
		InteresesOrdinarios: string;
		InteresesMoratorios: string;
		Accesorios: string;
		SaldoTotal: string;
		SaldoCapital: string;
		SaldoBalance: string;
		OriginadorNombre: string;
		NumCliente: number;
		EstatusSIC: number;
		MotivoEstatusSIC: string;
	}
	export interface Customer {
		NumCliente: string;
		ReferenciaHSBC: string;
		PrimerNombre: string;
		SegundoNombre: string;
		ApellidoPaterno: string;
		ApellidoMaterno: string;
		FechaNacimiento: Date;
		RFC: string;
		CURP: string;
		CalleNumero: string;
		Colonia: string;
		Municipio: string;
		Estado: string;
		CodigoPostal: number;
		TelefonoCasa: string;
		TelefonoEmpleo: string;
		TelefonoMovil: string;
		CorreoElectronico: string;
	}
	export interface PaymentType {
		Id: number;
		Name: string;
		Minimum: string;
		Unit: string;
		NumPayments: number;
		Amount: string;
		AmountNumber: number;
		PDLAvailable: number;
	}
	export interface PaymentOption {
		Amount: string;
		PaymentTypes: PaymentType[];
	}

	export interface Originador {
		Originador: number;
		OriginadorNombre: string;
		ClaveAgrupador: number;
		Grupo: string;
	}

	export interface Originadores {
		Originadores: Array<Originador>;
	}
    export interface Detalle {
        ConvenioId: number;
        Periodo: number;
        Vencimiento: Date;
        Monto: string;
        Referencia: string;
        FechaRealPago: Date;
        Servicio: string;
        CuentaBancaria: string;
    }
	
    export interface Encabezado {
        NumCliente: string;
        ConvenioId: number;
        RFC: string;
        FechaConvenio: Date;
        MontoTotal: string;
        PeriodicidadId: number;
        NumPagos: number;
        MontoPago: string;
        FechaPrimerVencimiento: Date;
        Fuente: string;
        GenerarDetalleConvenio: number;
        Periodicidad: string;
        PDF: string;
		ReferenciaOxxo: number;
		BANK: number;
		ORIGINATOR: number;
        Detalle: Detalle
    }

    export interface ConvenioDetalle {
        ConvenioDetalleId: number;
        ConvenioId: number;
        Periodo: number;
        Vencimiento: Date;
        Monto: string;
		Referencia: string;
		FechaRealPago: Date;
		Servicio: string;
		CuentaBancaria: string;
	}

	export interface Detalle {
		ConvenioDetalle: ConvenioDetalle[];
	}

	export interface Codigo {
		Codigo: number;
	}

	export interface Negociacion {
		Encabezado: Encabezado;
	}

	export interface SearchNegociacion {
		NumCliente: string;
		PrimerNombre: string;
		SegundoNombre: string;
		ApellidoPaterno: string;
		ApellidoMaterno: string;
		RFC: string;
		Convenio: string;
		Estatus: string;
		Detalle: Detalle
	}

	export function getSaldoTotal(info: Credito) {
		if (angular.isArray(info.Saldo)) {
			return (<Saldo>info.Saldo[0]).SaldoBalance;
		}
		return (<Saldo>info.Saldo).SaldoBalance;
	}
}
